import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useParams } from "react-router-dom";
import { ModuleManager } from "./modules/ModuleManager";
import { SectionManager } from "./sections/SectionManager";
import { ThemeEditor } from "./theme/ThemeEditor";

const PlatformConfigQuery = gql`
  query PlatformConfigForRoutes($platformId: ID!) {
    platform(platformId: $platformId) {
      id
      configuration {
        whitelabel
      }
    }
  }
`;

export function PlatformThemePage() {
  const { platformId } = useParams<{ platformId: string }>();
  const { data } = useQuery<any>(PlatformConfigQuery, {
    variables: { platformId },
    skip: !platformId,
  });
  const config = data?.platform?.configuration as
    | Record<string, unknown>
    | undefined;
  const theme = config?.theme as Record<string, string> | undefined;

  if (!platformId) return null;

  return <ThemeEditor platformId={platformId} initialTheme={theme} />;
}

export function PlatformSectionsPage() {
  const { platformId } = useParams<{ platformId: string }>();

  if (!platformId) return null;

  return <SectionManager platformId={platformId} templateContent="" />;
}

export function PlatformModulesPage() {
  const { platformId } = useParams<{ platformId: string }>();

  if (!platformId) return null;

  return <ModuleManager platformId={platformId} />;
}
